import formatRelativeDatetimes from './formatRelativeDatetimes'

// Ignore mutations if they target only elements of one of these classes
const observerTargetClassBlacklist = [
  "textoverlay",
  "js-localized-datetime"
];

// Some locale codes are different between Localize.js and Moment.js
const localeMap = {
  "en-GB": "en-gb",
  "zh": "zh-cn"
};

// monthYear & monthDay will translate month names but are not fully localized formats.
const formatMap = {
  dateshorthand: "l",
  date: "ll",
  time: "LT",
  datetime: "lll",
  monthYear: "MMMM YYYY",
  monthDay: "MMM D"
};
let observer = null;

const isBlacklisted = (mutationList) => {
  const classNames = _.uniq(_.map(mutationList, mutation => mutation.target.className));
  return (classNames.length === 1) && !!observerTargetClassBlacklist.indexOf(classNames[0]);
};

const setDate = function(el, locale) {
  const timestamp  = el.getAttribute("data-timestamp");

  return el.innerText = moment(timestamp).parseZone().locale(localeMap[locale] || locale).format(getFormat(el));
};

const getFormat = (el) => {
  const formatType = el.getAttribute("data-format-type");
  return formatMap[formatType];
};

const setDateRange = (el, locale) => {
  if (locale === "en") {
    el.innerText = el.getAttribute("data-formatted-date-range");
  } else {
    const startDate = el.getAttribute("data-timestamp-from");
    const endDate   = el.getAttribute("data-timestamp-to");
    const format    = getFormat(el);

    const formattedStartDate = moment(startDate).parseZone().locale(localeMap[locale] || locale).format(format);
    const formattedEndDate   = moment(endDate).parseZone().locale(localeMap[locale] || locale).format(format);
    el.innerText = formattedStartDate === formattedEndDate ? `${formattedStartDate}` : `${formattedStartDate} - ${formattedEndDate}`;
  }

  return el.innerText;
};

function formatDatetimes(locale, mutationList) {
  if (isBlacklisted(mutationList)) { return; }

  formatRelativeDatetimes(locale);

  const localizedDatetimes = document.querySelectorAll('[data-behavior="localized-datetime"]');

  localizedDatetimes.forEach(el => {
    if (el.getAttribute("data-localized-datetime") === locale) return;

    if (el.hasAttribute("data-formatted-date-range")) {
      setDateRange(el, locale);
    } else {
      setDate(el, locale);
    }

    return el.setAttribute("data-localized-datetime", locale);
  });
};


const startObserver = (locale) => {
  const callback = formatDatetimes.bind(this, locale);
  callback();
  observer = new MutationObserver(callback);
  return observer.observe(document.getElementById("page-container"), { childList: true, subtree: true });
};

const setDatetimeLocale = (locale) => {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
  return startObserver(locale);
};

export default setDatetimeLocale;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/datetimeLocale.js